import { escapeHtml, formatFileSize } from './file-utils';
import { SELECTORS } from './upload-constants';

const ERROR_DISMISS_DURATION = 10000;
const ERROR_DISMISS_PROGRESS_PROPERTY = '--frm-upload-error-dismiss-progress';

const startErrorDismissCountdown = (errorElement, duration = ERROR_DISMISS_DURATION) => {
	const start = performance.now();

	const updateProgress = (now) => {
		if (!errorElement.isConnected) {
			return;
		}

		const elapsed = now - start;
		const remainingPercent = Math.max(0, 100 - (elapsed / duration) * 100);
		errorElement.style.setProperty(ERROR_DISMISS_PROGRESS_PROPERTY, `${remainingPercent}%`);

		if (elapsed >= duration) {
			errorElement.remove();
			return;
		}

		requestAnimationFrame(updateProgress);
	};

	requestAnimationFrame(updateProgress);
};

export const createPreview = (file, fileId, options = {}) => {
	const removeFileLabel = options.removeFileLabel || 'Remove file';
	const countLabel = options.countLabel || '1/1';
	const preview = document.createElement('div');
	preview.className = 'frm_upload_file_preview';
	preview.dataset.fileId = fileId;
	preview.innerHTML = `
		<span class="frm_upload_preview_count">${countLabel}</span>
		<p class="frm_upload_file">
			<span class="frm_upload_filename">${escapeHtml(file.name)}</span>
			<small class="frm_upload_file_size">(${formatFileSize(file.size)})</small>
		</p>
		<div class="frm_upload_preview_progress">
			<div class="frm_upload_progress_bar">
				<div class="frm_upload_progress_fill"></div>
			</div>
			<small class="frm_upload_progress_text">0%</small>
		</div>
		<button class="frm_upload_preview_remove_file material-symbols-rounded" type="button" title="${escapeHtml(removeFileLabel)}" aria-label="${escapeHtml(removeFileLabel)}">delete</button>
	`;
	return preview;
};

export const updatePreviewCounts = (previewContainer, maxFiles) => {
	const previews = Array.from(previewContainer.querySelectorAll(SELECTORS.previewItem));

	previews.forEach((preview, index) => {
		const countElement = preview.querySelector(SELECTORS.previewCount);
		if (countElement) {
			countElement.textContent = `${index + 1}/${maxFiles}`;
		}
	});
};

export const showError = (container, message) => {
	const errorElement = document.createElement('div');
	errorElement.className = 'frm_upload_error_message';
	errorElement.textContent = message;
	errorElement.style.setProperty(ERROR_DISMISS_PROGRESS_PROPERTY, '100%');
	container.appendChild(errorElement);
	startErrorDismissCountdown(errorElement);
};
